import { ANONYMOUS_USERNAME } from '@core/routes'

/** Minimal audio shape the ownership check needs — structurally satisfied by `TAudioSimple`. */
type TOwnableAudio = {
    authorUsername: string
}

/**
 * Whether the current user owns this audio (audio-web's `isEditor`). Compares by username, not id,
 * to avoid the `authorId: string` / session `id: number` mismatch.
 *
 * Both guards matter: a guest's session `username` is `''` and `convertAudioSimple` passes an
 * empty `authorUsername` through, so without the first check an author-less audio would make every
 * guest its owner; and the anonymous account is shared, so nobody owns its uploads.
 */
export const isAudioOwner = (audio: TOwnableAudio, currentUsername: string): boolean =>
    currentUsername !== '' &&
    audio.authorUsername === currentUsername &&
    audio.authorUsername !== ANONYMOUS_USERNAME
